// Seeded PRNG (mulberry32) so procedurally drawn artwork renders the same on every visit.
export const createRng = (seed = 1) => {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

export const between = (rng, min, max) => min + (max - min) * rng();

export const pick = (rng, list) => list[Math.floor(rng() * list.length)];

export const round = (n) => Math.round(n * 100) / 100;
